module.exports = __webpack_public_path__ + "static/zh-Hant-dad85e6e730ca53592e90ba067d451b8.svg";